import React from "react";

/**
 * Başkanın Mesajı — light editorial page with the President's message.
 * Uses the same bright/airy style as Anasayfa2 (home-light scope keeps the
 * light backgrounds while shared Header/Footer remain dark navy).
 */
export default function PresidentMessagePage() {
  return (
    <div data-testid="president-message" className="home-light bg-white">
      {/* Hero — title only */}
      <section className="bg-[#FBFAF6] py-20 border-b border-[#E5E7EB]">
        <div className="useko-container text-center">
          <h1
            className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-[#0B1837] tracking-tight leading-tight"
            data-testid="pm-title"
          >
            Başkanın Mesajı
          </h1>
          <div className="w-16 h-1 bg-[#D4A94F] mx-auto mt-8" aria-hidden="true"/>
        </div>
      </section>

      {/* Featured image */}
      <section className="bg-white pt-12 md:pt-16">
        <div className="useko-container max-w-4xl">
          <div className="w-full aspect-[16/7] overflow-hidden rounded-2xl border border-[#E5E7EB] shadow-sm">
            <img
              src="https://customer-assets-39nsmqrw.emergentagent.net/job_useko-web/artifacts/lcvh2y2w_3-baskanmesaj.png"
              alt="Başkandan Mesaj"
              loading="lazy"
              className="w-full h-full object-cover"
              data-testid="pm-hero-image"
            />
          </div>
        </div>
      </section>

      {/* Message body — editorial, generous line-height */}
      <section className="py-16 md:py-24 bg-white">
        <article className="useko-container max-w-3xl">
          <div className="text-[17px] md:text-[18px] leading-[1.9] text-[#374151] space-y-6" data-testid="pm-body">
            <p className="font-heading text-xl md:text-2xl text-[#0B1837] font-semibold">
              Değerli Ziyaretçilerimiz ve Kıymetli Paydaşlarımız;
            </p>

            <p>
              Dünya hızla değişirken, ekonomik kalkınma, uluslararası iş birliği ve sürdürülebilir gelişim artık ortak akıl ve güçlü ortaklıklarla mümkün hâle gelmektedir. Günümüzün küresel sorunları, ülkeler, kurumlar ve toplumlar arasında güvene dayalı iş birliklerini her zamankinden daha önemli kılmaktadır.
            </p>

            <p>
              USEKO, bu anlayış doğrultusunda Türkiye'de kurulmuş uluslararası vizyona sahip bir sivil toplum kuruluşudur.
            </p>

            <p>
              Amacı; kamu kurumları, özel sektör, akademi, sivil toplum ve uluslararası kuruluşlar arasında sürdürülebilir iş birlikleri geliştirerek ekonomik kalkınmaya, ticari diplomasiye ve toplumsal gelişime katkı sağlamaktır.
            </p>

            <p>
              Türkiye'nin üretim gücünü, girişimcilik potansiyelini ve stratejik kapasitesini uluslararası alanda daha görünür kılmayı hedefleyen USEKO; yatırım, ticaret, eğitim, kültürel diplomasi ve sosyal kalkınma alanlarında kalıcı ortaklıklar oluşturmayı öncelikli görevleri arasında görmektedir.
            </p>

            <p>
              Bizler, gerçek başarının yalnızca ekonomik büyüme ile değil; güven, bilgi, etik değerler ve ortak fayda anlayışıyla mümkün olduğuna inanıyoruz. Bu nedenle yürütülen her çalışmanın toplumlara değer katmasını, gelecek nesillere umut vermesini ve sürdürülebilir kalkınmaya katkı sağlamasını esas alıyoruz.
            </p>

            <p>
              USEKO çatısı altında kurulacak her iş birliğinin; ülkeler arasında dostluğu güçlendireceğine, ekonomik gelişimi destekleyeceğine ve daha adil, kapsayıcı ve sürdürülebilir bir geleceğin inşasına katkı sunacağına yürekten inanıyorum.
            </p>

            <p>
              Bu ortak vizyonu paylaşan tüm kurumları, iş dünyasını, akademiyi ve sivil toplumu birlikte üretmeye, birlikte gelişmeye ve birlikte geleceği inşa etmeye davet ediyorum.
            </p>

            <blockquote className="border-l-4 border-[#D4A94F] ps-6 py-2 my-8 font-heading text-xl md:text-2xl text-[#0B1837] italic">
              Çünkü inanıyoruz ki; en güçlü köprüler güvenle kurulur, en kalıcı başarı ise birlikte yükselmektir.
            </blockquote>

            <p className="text-[#0B1837] font-medium">Saygılarımla…</p>

            <div className="pt-8 mt-8 border-t border-[#E5E7EB]">
              <div className="font-heading text-2xl font-bold text-[#0B1837]">USEKO</div>
              <div className="text-sm text-[#4B5563] mt-1">Genel Başkan</div>
            </div>
          </div>
        </article>
      </section>
    </div>
  );
}
